export default function getSeconds(time01 = ''): number {
  // if no text
  if (time01?.length === 0) {
    return 0;
  }

  // when just seconds => 00 or 0
  if (time01?.length === 1) {
    return Number(time01);
  }
  if (time01?.length === 2) {
    return Number(time01);
  }
  if (time01?.length === 3) {
    const seconds = time01.replace(':', '');
    return Number(seconds);
  }

  // when minuts and seconds => 00:00 or 00:0 or 00:
  if (time01?.length === 4) {
    const time001 = time01.split(':');
    const minuts001 = Number(time001[0]);
    const seconds001 = Number(time001[1]);
    const minutsToSEconds = minuts001 * 60;
    const secondsTotal = minutsToSEconds + seconds001;
    return secondsTotal;
  }
  if (time01?.length === 5) {
    const time001 = time01.split(':');
    const minuts001 = Number(time001[0]);
    const seconds001 = Number(time001[1]);
    const minutsToSEconds = minuts001 * 60;
    const secondsTotal = minutsToSEconds + seconds001;
    return secondsTotal;
  }

  // when hr, minuts and seconds =>  00:00:00
  const time001 = time01?.split(':');
  const hr001 = Number(time001 ? time001[0] : 0);
  const minuts001 = Number(time001 ? time001[1] : 0);
  const seconds001 = Number(time001 ? time001[2] : 0);
  const minutsToSEconds = minuts001 * 60;
  const hrToSeconds = hr001 * 3600;
  const secondsTotal = minutsToSEconds + hrToSeconds + seconds001;
  return secondsTotal;
}
